/**
 * @generated SignedSource<<62fd5d4070938b4c4a2c95f205ab44d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EmailPreloaderQuery$variables = {
  email?: string | null;
  encryptedEmail?: string | null;
};
export type EmailPreloaderQuery$data = {
  readonly hubspotLead: {
    readonly email: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
  } | null;
};
export type EmailPreloaderQuery = {
  response: EmailPreloaderQuery$data;
  variables: EmailPreloaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "encryptedEmail"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "encryptedEmail",
        "variableName": "encryptedEmail"
      }
    ],
    "concreteType": "HubspotLead",
    "kind": "LinkedField",
    "name": "hubspotLead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailPreloaderQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailPreloaderQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ca17cbc0e55484f754a55d2f6fedf04a",
    "id": null,
    "metadata": {},
    "name": "EmailPreloaderQuery",
    "operationKind": "query",
    "text": "query EmailPreloaderQuery(\n  $email: String\n  $encryptedEmail: String\n) {\n  hubspotLead(email: $email, encryptedEmail: $encryptedEmail) {\n    email\n    firstName\n    lastName\n  }\n}\n"
  }
};
})();

(node as any).hash = "1898e35abb12b64ad5a9a48d81b4e8c8";

export default node;
